import { ReleaseModeClient } from 'front-office/view-models/release-mode';
import { HeadCell } from 'shell/components/shared/table/types';
import * as yup from 'yup';

export const headCells: HeadCell<ReleaseModeClient, keyof ReleaseModeClient>[] = [
  {
    id: 'code',
    label: 'Codice',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'register',
    label: 'Registro',
  },
  {
    id: 'exemption',
    label: 'Esenzione',
  },
  {
    id: 'use',
    label: 'Uso',
  },
  {
    id: 'dateFrom',
    label: 'Validità dal',
  },
  {
    id: 'dateTo',
    label: 'Validità al',
  },
  {
    id: 'action',
    label: '',
  },
];

export const validationSchemaFilter = yup.object({});
